import './App.css';
import InboxMessages from "./components/Inbox/InboxMessages";
import { AppProvider } from "./AppContext";


function App() {
  return (
    <AppProvider>
    <InboxMessages />
    </AppProvider>
  );
}

export default App;
